var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 50,
    viewBox: "0 0 33 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3297_9947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9268 16.4634C32.9268 23.2617 24.6951 32.9268 17.9878 42.0732C17.0935 43.2927 15.8333 43.2927 14.939 42.0732C8.23171 32.9268 0 23.4422 0 16.4634C0 7.37093 7.37093 0 16.4634 0C25.5559 0 32.9268 7.37093 32.9268 16.4634Z",
    fill: "#005150"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M16.4634 0C7.37093 0 0 7.37093 0 16.4634C0 23.4422 8.23171 32.9268 14.939 42.0732C15.8537 43.3204 17.0935 43.2927 17.9878 42.0732C24.6951 32.9268 32.9268 23.2617 32.9268 16.4634C32.9268 7.37093 25.5559 0 16.4634 0ZM16.4634 1.21951C24.8968 1.21951 31.7073 8.03 31.7073 16.4634C31.7073 19.3887 29.8727 23.392 27.0984 27.7296C24.3241 32.0672 20.3721 36.7588 17.0041 41.3515C16.7602 41.6839 16.6009 41.8569 16.4634 42.0017C16.326 41.8569 16.1666 41.6839 15.9227 41.3515C12.5421 36.7415 9.04253 32.0905 6.11661 27.7724C3.19071 23.4545 1.21951 19.4555 1.21951 16.4634C1.21951 8.03 8.03 1.21951 16.4634 1.21951Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.4637 7.31738C11.414 7.31738 7.31738 11.414 7.31738 16.4637C7.31738 21.5135 11.414 25.6101 16.4637 25.6101C21.5135 25.6101 25.6101 21.5135 25.6101 16.4637C25.6101 11.414 21.5135 7.31738 16.4637 7.31738ZM15.9871 23.7954V18.0584H12.7979L17.3802 9.13199V14.8691H20.4503L15.9871 23.7954Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3297_9947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.9268,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarker);
export default __webpack_public_path__ + "static/media/location-marker.1e5c7ff9c5c8559708f684fe42679fc1.svg";
export { ForwardRef as ReactComponent };